import React from 'react';
import './index.scss';
import {toJS} from 'mobx';

import {api} from '../../../../functions/api'

import Icon from '@mdi/react'
import {mdiPlus} from '@mdi/js'

import CircularProgress from '@material-ui/core/CircularProgress';

import Search from '../../../../components/basic/search';
import CustomButton from '../../../../components/basic/CustomButton'
import CustomSnackbar from '../../../../components/global/snackbar'
import DeleteDialog from '../../../../components/global/deleteDialog'
import AddRepresentant from './add'


import { inject, observer } from 'mobx-react';
import CustomCard from '../../../../components/basic/CustomCard';

const TIMEOUT = 3000;

@inject('translate')
@inject('internal')
@observer
export default class ClientRepresentants extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            openSnackbar: false,
            message: "",
            openAddRepresentantDlialog: false,
        }
    }

    componentDidMount() {
        this.loadClientRepresentants();
        //this.props.internal.setRoute( this.props.history, this.props.location.pathname)
        this.props.internal.setRoute( this.props.routerData.history, this.props.routerData.location.pathname)
    }

    timeout = null;
    componentWillUnmount() {
        clearTimeout(this.timeout)
    }

    turnOffSnackBar = () => {
        clearTimeout(this.timeout)
        this.timeout =  setTimeout(() => {
            this.setState({message: "", openSnackbar: false})
        }, TIMEOUT)
    }

    loadClientRepresentants = async (size = 10, page = 0, searchterm = "", by = "last_name", dir = "asc") => {
        let idClient = toJS(this.props.routerData.match.params.idClient)
        let load_data = await api({
            method:'get',
            url:'clients/'+idClient+"/admins",
            authorization: this.props.internal.user.access_token,
            params:{
                searchterm: searchterm,
                page:{
                    number:page,
                    size:size,
                },
                order: [
                    {
                        by: by,
                        dir: dir
                    }
                ],
                
            }
        })


        if(load_data.success === true) {
            if(load_data.data) {
                
                this.props.internal.setDataForTable(load_data.data)
            }
        }
        this.setState({loading: false})
    }

    handleSearch = (searchTerm) => {
        
        if(searchTerm.length > 2) {
            this.loadClientRepresentants(10, 0, searchTerm)
        }
        else {
            this.loadClientRepresentants()
        }
        
    }

    handleOpenAddRepresentantDlialog = () => {
        this.setState({openAddRepresentantDlialog: !this.state.openAddRepresentantDlialog})
    }
    handleCloseAddRepresentantDlialog = () => {
        this.setState({openAddRepresentantDlialog: !this.state.openAddRepresentantDlialog})
    }
    handleDeleteRepresentant = async () => {
        let adminId = toJS(this.props.internal.actionDeleteObj.id)
        
        let idClient = toJS(this.props.routerData.match.params.idClient)
        let update_data = await api({
            method:'delete',
            url:'clients/'+idClient+"/admins-pair",
            // url:'clients/'+"0"+"/admins-pair",
            authorization: this.props.internal.user.access_token,
            params: {
                ids: [adminId]
            }
        })
        if(update_data.success === true) {
            // this.setState({message: update_data.data.message, openSnackbar: true})
            this.props.internal.setSnackbar(update_data.data.message, true)
        }
        else {
            // this.setState({message: update_data.data.message, openSnackbar: true})
            this.props.internal.setSnackbar(update_data.data.message, true)
        }
        this.loadClientRepresentants()
        this.turnOffSnackBar();
        this.props.internal.setActionDelete();
    }
    
    handleAddNewRepresentant = async(data, primary) => {
        let admins_paired = toJS(this.props.internal.dataForTable.lists.admins_paired)

        admins_paired.push(Number(data));

        let idClient = toJS(this.props.routerData.match.params.idClient)
        let update_data = await api({
            method:'patch',
            url:'clients/'+idClient+"/admins-pair",
            // url:'clients/'+"0"+"/admins-pair",
            authorization: this.props.internal.user.access_token,
            params: {
                id: data,
                primary: primary
            }
        })
        if(update_data.success === true) {
            this.props.internal.setSnackbar(update_data.data.message, true)
            // this.setState({message: update_data.data.message, openSnackbar: true})
        }
        else {
            this.props.internal.setSnackbar(update_data.data.message, true)
            // this.setState({message: update_data.data.message, openSnackbar: true})
        }
        
        this.turnOffSnackBar();
        
        this.setState({openAddRepresentantDlialog: false})
        this.loadClientRepresentants()
    }

    changeStatus = (id, checked) => {
        this.handleAddNewRepresentant(id, checked)
    }

    render() {
        let permissions;
        if(!this.state.loading) {
            permissions = toJS(this.props.internal.user.data.permissions.clients_admins);
        }
        return (
            <div className={'client-users-representants'}>
                <CustomSnackbar message={this.state.message} open={this.state.openSnackbar} />
                <DeleteDialog
                    open={this.props.internal.actionDelete}
                    title={this.props.translate.i18n.MODULES.CLIENTS.DELETE_REPRESENTANT_TITLE}
                    content={this.props.translate.i18n.GLOBAL.ALERTS.DELETE_ITEM}
                    btn_cancel={this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                    btn_delete={this.props.translate.i18n.GLOBAL.BUTTONS.DELETE}
                    delete={this.handleDeleteRepresentant}
                />
                {this.state.openAddRepresentantDlialog?
                <AddRepresentant
                    open={this.state.openAddRepresentantDlialog}
                    onClose={this.handleCloseAddRepresentantDlialog}
                    title={this.props.translate.i18n.MODULES.CLIENTS.ADD_NEW_REPRESENTANT_DIALOG_TITLE}
                    routerData={this.props.routerData}
                    showSnackbar={this.showSnackbar}
                    representants={this.props.internal.dataForTable.lists.admins}
                    createNewRepresentant={this.handleAddNewRepresentant}
                />: null}
                <div className={'flex space-between'}>
                    <Search placeholder={this.props.translate.i18n.MODULES.CLIENTS.REPRESENTATS_SEARCH} classes={'client-search'} onChange={this.handleSearch}/>
                    {!this.state.loading && permissions.update
                        ?
                        <CustomButton
                        mystyle={'btn-orange-bg border-radius-18'}
                            title={this.props.translate.i18n.MODULES.CLIENTS.CREATE_NEW_REPRESENTANT}
                            onClick={this.handleOpenAddRepresentantDlialog}
                        >
                            <Icon path={mdiPlus} size={1}  />
                        </CustomButton>
                        :
                        null
                    }
                </div>
                <div className={'representants-container'}>
                    {this.state.loading ?
                        <CircularProgress className={'circular-progress'} />
                        :
                        
                        toJS(this.props.internal.dataForTable.data).length > 0
                            ?
                            <div className={'flex card-container'}>
                            {this.props.internal.dataForTable.data.map((data, index) => {
                            return (
                                <CustomCard
                                    id={data.id}
                                    key={data.id}
                                    username={data.username}
                                    email={data.email}
                                    phone={data.data ? data.data.phone : null}
                                    src={data.photo}
                                    primary={data.is_primary}
                                    changePrimaryStatus={this.changeStatus}
                                />
                            );
                            })}
                            </div>
                            :
                            <div className={'client-not-representants'}>{this.props.translate.i18n.MODULES.CLIENTS.CLIENT_DOES_NOT_HAVE_REPRESENTANTS}</div>
                        }
                        {/* null} */}
                    </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/clients/detail/representants/index.js